import { render } from "./SelectLinkedSource.vue?vue&type=template&id=35ab711e&scoped=true"
import script from "./SelectLinkedSource.vue?vue&type=script&lang=js"
export * from "./SelectLinkedSource.vue?vue&type=script&lang=js"

import "./SelectLinkedSource.vue?vue&type=style&index=0&id=35ab711e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ab711e"]])

export default __exports__